import { render, staticRenderFns } from "./SharedFiles.vue?vue&type=template&id=c7640d72&"
import script from "./SharedFiles.vue?vue&type=script&lang=js&"
export * from "./SharedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports